import React, { useState } from "react";
// import tlmData from "../../test/tlm.json";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import StackedBarChart from "../../../../components/charts/StackedBarChart"; // Adjust the import path as needed
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BarChart from "../../../../components/charts/Bar";
// import costData from "../../test/cost.json";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function TlmDetails() {
  const dashboardData = useSelector((state) => state.dashboard.jsonData);

  const tlmData = dashboardData?.tlm_values || [];
  const costData = dashboardData?.cost_categories || [];

  const history = useHistory();
  const { t } = useTranslation();
  const [selectedThreat, setSelectedThreat] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const tlmMinSum = tlmData.reduce((sum, item) => sum + item["mean"], 0);
  const tlmMedianSum = tlmData.reduce((sum, item) => sum + item["median"], 0);
  const tlmMaxSum = tlmData.reduce((sum, item) => sum + item["95th"], 0);
  const baseDescription = "Select a threat to get description";

  const tlmMinToDisplay = selectedThreat
    ? tlmData.find((item) => item.threat === selectedThreat)?.["mean"] || 0
    : tlmMinSum;

  const tlmMedianToDisplay = selectedThreat
    ? tlmData.find((item) => item.threat === selectedThreat)?.["median"] || 0
    : tlmMedianSum;

  const tlmMaxToDisplay = selectedThreat
    ? tlmData.find((item) => item.threat === selectedThreat)?.["95th"] || 0
    : tlmMaxSum;

  const tlmDescriptionToDisplay = selectedThreat
    ? tlmData.find((item) => item.threat === selectedThreat)?.["justification"]
    : baseDescription;

  const costDisplayData = selectedCategory
    ? costData
        .filter(
          (item) =>
            item.category === selectedCategory &&
            item.min !== undefined &&
            item.max !== undefined
        )
        .map(({ category, min, max }) => ({ category, min, max }))
    : costData
        .filter((item) => item.min !== undefined && item.max !== undefined)
        .map(({ category, min, max }) => ({ category, min, max }));

  const values = [
    tlmMinToDisplay.toFixed(2),
    tlmMedianToDisplay.toFixed(2),
    tlmMaxToDisplay.toFixed(2),
  ];
  const labels = ["Mean", "Median", "95th Percentile"];
  const formatCurrency = (value) => {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });
  };

  function handleChange(event) {
    setSelectedThreat(event.target.value);
  }

  function handlGoBack() {
    history.goBack();
  }
  const handleInfoClick = (path) => history.push(path);

  return (
    <>
      <Box sx={{ marginBottom: { xs: "25%" } }}>
        <Button
          sx={{
            background: "#78c3ae",
            borderRadius: 4,
            fontSize: "16px",
            marginLeft: { xs: "8px", sm: "5px" }, // Remove marginLeft on mobile
            alignSelf: "flex-start",

            "&:hover": {
              backgroundColor: "#60dbb9",
            },
          }}
          onClick={handlGoBack}
        >
          <ArrowBackIcon sx={{ color: "white" }} />
        </Button>
        <Typography sx={{ textAlign: "center", fontSize: "40px" }}>
          Threat Loss Magnitude
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "stretch",
            maxWidth: "100%",
            margin: "auto",
            mt: { xs: 2, sm: 2 },
            px: { xs: 1, sm: 2 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              flexWrap: "wrap",
              gap: { xs: 2, sm: 2 },
              flex: 1,
              width: "100%",
            }}
          >
            {/* Box 1: Threat selection */}
            <Box
              sx={{
                boxShadow: 3,
                borderRadius: 2,
                p: { xs: 2, sm: 3 },
                bgcolor: "background.paper",
                width: {
                  xs: "90%", // Full width on extra small screens
                  sm: "calc(25% - 16px)", // 25% width on small screens
                  md: "calc(20% - 32px)", // Smaller width (20%) on big screens
                },
                flex: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: 180,
              }}
            >
              <FormControl fullWidth>
                <InputLabel
                  id="threat-select-label"
                  sx={{ fontSize: { xs: "1rem", sm: "1.2rem" } }}
                >
                  Threat Type
                </InputLabel>
                <Select
                  labelId="threat-select-label"
                  id="threat-select"
                  value={selectedThreat}
                  label="Threat Type"
                  onChange={handleChange}
                  sx={{
                    height: { xs: "52px", sm: "64px" },
                    fontSize: { xs: "1rem", sm: "1.25rem" },
                  }}
                >
                  <MenuItem
                    value=""
                    sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
                  >
                    <em>All threats</em>
                  </MenuItem>
                  {tlmData.map((threat, index) => (
                    <MenuItem
                      key={index}
                      value={threat.threat}
                      sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
                    >
                      {t(threat.threat)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {/* Box 2: TLM Min */}
            <Box
              sx={{
                boxShadow: 3,
                borderRadius: 2,
                p: { xs: 2, sm: 3 },
                bgcolor: "background.paper",
                width: {
                  xs: "90%",
                  sm: "calc(25% - 16px)",
                  md: "calc(20% - 32px)",
                },
                flex: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: 180,
                position: "relative",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                TLM Mean
              </Typography>
              <Typography
                variant="h4"
                color="primary"
                sx={{ fontSize: { xs: "1.75rem", sm: "2.125rem" } }}
              >
                {(tlmMinToDisplay / 1000).toFixed()} M$
              </Typography>
            </Box>

            {/* Box 3: TLM Median */}
            <Box
              sx={{
                boxShadow: 3,
                borderRadius: 2,
                p: { xs: 2, sm: 3 },
                bgcolor: "background.paper",
                width: {
                  xs: "90%",
                  sm: "calc(25% - 16px)",
                  md: "calc(20% - 32px)",
                },
                flex: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: 180,
                position: "relative",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                TLM Median
              </Typography>
              <Typography
                variant="h4"
                color="primary"
                sx={{ fontSize: { xs: "1.75rem", sm: "2.125rem" } }}
              >
                {(tlmMedianToDisplay / 1000).toFixed()} M$
              </Typography>
            </Box>

            {/* Box 4: TLM Max */}
            <Box
              sx={{
                boxShadow: 3,
                borderRadius: 2,
                p: { xs: 2, sm: 3 },
                bgcolor: "background.paper",
                width: {
                  xs: "90%",
                  sm: "calc(25% - 16px)",
                  md: "calc(20% - 32px)",
                },
                flex: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: 180,
                position: "relative",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                TLM 95th Percentile
              </Typography>
              <Typography
                variant="h4"
                color="primary"
                sx={{ fontSize: { xs: "1.75rem", sm: "2.125rem" } }}
              >
                {(tlmMaxToDisplay / 1000).toFixed()} M$
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Add StackedBarChart here */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: 2, sm: 4 },
            mt: 4,
            px: { xs: 1, sm: 2 },
          }}
        >
          <Box
            sx={{
              boxShadow: 3,
              borderRadius: 2,
              p: { xs: 2, sm: 3 },
              bgcolor: "background.paper",
              width: { xs: "90%", sm: "90%", md: "90%" },
              minHeight: "100px",
              height: "auto",
              textAlign: "center",
            }}
          >
            <StackedBarChart
              values={values}
              labels={labels}
              min={0}
              max={tlmMaxToDisplay}
            />
          </Box>
        </Box>
        {/* Threat description */}

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            alignItems: "flex-start",
            gap: { xs: 2, sm: 4 },
            mt: 4,
            px: { xs: 1, sm: 2 },
          }}
        >
          {/* BarChart Box (DoughnutPieChart remains unchanged) */}
          <Box
            sx={{
              boxShadow: 3,
              borderRadius: 2,
              p: { xs: 2, sm: 3 },
              bgcolor: "background.paper",
              width: { xs: "90%", sm: "45%", md: "40%" },
              minHeight: "450px",
              height: "auto",
              textAlign: "center",
              position: "relative",
            }}
          >
            <IconButton
              aria-label="info"
              size="small"
              onClick={() => handleInfoClick("/risk_profile/cost")}
              sx={{
                position: "absolute", // Use absolute positioning
                top: 8, // Adjust spacing from the top
                right: 8, // Adjust spacing from the right
                color: "text.secondary",
                zIndex: 1,
              }}
            >
              <InfoIcon fontSize="large" color="success" />
            </IconButton>
            <BarChart
              data={costDisplayData}
              xKey="category" // Explicitly set xKey to match the key in your data
              xLabel="Category" // Label for the x-axis
              yLabel="Cost ($)" // Label for the y-axis
              title="Cost categories" // Title of the chart
            />
          </Box>

          {/* Description Box */}

          <Box
            sx={{
              boxShadow: 3,
              borderRadius: 2,
              p: { xs: 2, sm: 3 },
              bgcolor: "background.paper",
              width: { xs: "90%", sm: "45%", md: "40%" },
              minHeight: "450px",
              height: "auto",
              textAlign: "start",
            }}
          >
            <Typography>{tlmDescriptionToDisplay}</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
